import { render, staticRenderFns } from "./CallsChart.vue?vue&type=template&id=29baa041&scoped=true"
import script from "./CallsChart.vue?vue&type=script&lang=js"
export * from "./CallsChart.vue?vue&type=script&lang=js"
import style0 from "./CallsChart.vue?vue&type=style&index=0&id=29baa041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29baa041",
  null
  
)

export default component.exports